<!-- Para maiores informações sobre o d3 -> https://www.tutorialsteacher.com/d3js/create-bar-chart-using-d3js -->
<template>
    <div class="cockpit-chart">
        <!-- TÍTULO -->
        <div class="chart-title">
            <router-link
                v-if="linked"
                div="span"
                :to="{
                    name: 'ven-cockpit-chart',
                    params: { tipo: datacontent.titulo },
                }"
            >
                {{ title }}
            </router-link>
            <div v-else>{{ title }}</div>
            <div style="display: inline-block; cursor: pointer; padding-right: 4px">
                <span class="zoom-icon" v-tippy :title="$t('zoom-close')">
                    <svg class="svg-icons" @click="closeZoom()" v-if="zoomned && hasZoom">
                        <use
                            :xlink:href="require('@/assets/img/icons/zoom-close.svg') + '#layer'"
                        ></use>
                    </svg>
                </span>

                <span class="zoom-icon" v-tippy :title="!zoomned ? $t('zoom-in') : $t('zoom-out')">
                    <svg class="svg-icons" @click="zoom()">
                        <use
                            v-if="!zoomned"
                            :xlink:href="require('@/assets/img/icons/zoom-in.svg') + '#layer'"
                        ></use>
                        <use
                            v-else
                            :xlink:href="require('@/assets/img/icons/zoom-out.svg') + '#layer'"
                        ></use>
                    </svg>
                </span>
                <div
                    v-if="info != null"
                    style="display: inline-block; cursor: pointer; margin-left: 10px"
                >
                    <b-icon icon="information" v-tippy :title="getTranslation(info)" />
                </div>
            </div>
        </div>

        <!-- CONTEÚDO -->
        <div ref="chartContent" class="chart-content group-bar-chart" v-if="!noData && !loading">
            <svg class="chart_v" ref="svgcontent"></svg>
        </div>

        <!-- FOOTER -->
        <div class="chart-footer" v-if="!noData && !loading">
            <div ref="LGbox" class="legend-chart"></div>
        </div>

        <!-- MSG NÃO HÁ DADOS -->
        <div class="no-data bar" v-if="noData && !loading">
            <svg class="fail">
                <use :xlink:href="require('@/assets/img/icons/chart-error.svg') + '#layer'"></use>
            </svg>
            <div>{{ $t('chart-no-data') }}</div>
        </div>

        <!-- MSG NÃO HÁ DADOS -->
        <div class="no-data bar" v-if="loading">
            <svg class="loading">
                <use :xlink:href="require('@/assets/img/icons/loader.svg') + '#layer'"></use>
            </svg>
            <div>{{ $t('carregando') }}...</div>
        </div>
    </div>
</template>

<script>
import CockpitChart from '@/components/shared/chart/CockpitChart';
import CockpitVendasService from '@/services/CockpitVendasService';
import CockpitDespesasService from '@/services/CockpitDespesasService';
import CockpitAgroService from '@/services/agro/cockpit/CockpitAgroService';
import { palette as paleta } from '@/functions/color/Palette';

export default {
    extends: CockpitChart,
    props: {
        title: {
            type: String,
            default: '',
        },
        datacontent: {
            type: Object,
            default: () => {
                return {};
            },
        },
        filtro: {
            type: Object,
            default: () => {
                return {};
            },
        },
        direction: {
            type: String,
            default: 'v',
        },
        linked: {
            type: Boolean,
            default: false,
        },
        module: {
            type: String,
            default: 'VENDAS', // vendas, despesas, promotor
        },
        info: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            cores: [],
            cores2: [],
            datacaption: {},
            filtered: [],
            filteredZoom: [],
            service: null,
            tooltipDiv: null,
            formatter: new Intl.NumberFormat(),
            loading: true,
            zoomned: false,
            hasZoom: false,
            datasetFormated: [],
        };
    },
    created() {
        if (this.module == 'DESPESAS') {
            this.service = new CockpitDespesasService(this.$http, this.$router);
        } else if (this.module == 'AGRO') {
            this.service = new CockpitAgroService(this.$http, this.$router);
        } else {
            this.service = new CockpitVendasService(this.$http, this.$router);
        }
        this.cores = paleta.getBarColors();
        this.cores2 = paleta.getAbcColor();

        if (!this.noData) {
            setTimeout(() => {
                this.mountChart();
                this.loading = false;
            }, 50);
        } else {
            this.loadData();
        }
    },
    computed: {
        noData() {
            return (
                !this.datacontent || !this.datacontent.items || this.datacontent.items.length == 0
            );
        },
        dataset() {
            if (this.datacontent && this.datacontent.items && this.datacontent.items.length > 0) {
                let items = this.datacontent.items;

                items = items.map(function (d) {
                    let obj = {};
                    obj['grupo'] = d.row;
                    d.values.map(function (e) {
                        obj[e.name] = e.value;
                    });

                    return obj;
                });

                return items;
            } else {
                return [];
            }
        },
    },
    watch: {
        /* Se houver modificação no datacontent, ele redesenha o gráfico. */
        datacontent: {
            deep: true,
            handler(nc) {
                if (nc.items) {
                    this.redrawChart();
                }
            },
        },
    },
    methods: {
        loadData() {
            this.loading = true;
            this.service
                .getChartByTitulo(this.datacontent.titulo, this.filtro)
                .then((r) => {
                    if (r) {
                        this.$emit('update-content', r);
                    } else {
                        console.warn(`Card vazio: ${this.datacontent.titulo}`);
                    }
                })
                .catch((e) => {
                    console.error(`Erro em ${this.datacontent.titulo}`, e);
                })
                .finally((_) => {
                    this.loading = false;
                });
        },
        svgChart() {
            let d3 = this.$d3;
            //Para construir o gráfico
            let data = this.dataset;

            let selected = null;

            let brushed = () => {
                this.hasZoom = true;
                let extent = d3.event.selection;
                if (extent) {
                    let domainSize = x2.domain().length;
                    selected = x2.domain().filter(function (d, index) {
                        let fim = x2(x2.domain()[index + 1]) - 15;
                        if (index < domainSize - 1) {
                            return extent[0] <= fim && x2(d) <= extent[1];
                        } else {
                            return extent[0] <= width && x2(d) <= extent[1];
                        }
                    });
                }

                let start;
                let end;

                // Nesse momento ele está retornando os grupos que estão entre a seleção.
                if (extent && extent[0] != extent[1]) {
                    start = selected[0];
                    end = selected[selected.length - 1];
                    start = data.indexOf(data.filter((v) => v.grupo == start)[0]);
                    end = data.indexOf(data.filter((v) => v.grupo == end)[0]) + 1;
                } else {
                    start = 0;
                    end = data.length;
                }

                let updatedData = data.slice(start, end);

                if (selected) {
                    this.filtered = data
                        .map((v) => v.grupo) // armazena aqueles que não foram selecionados
                        .filter((v) => selected.indexOf(v) == -1);
                    this.filteredZoom = data // armazena aqueles que foram selecionados
                        .map((v) => v.grupo)
                        .filter((v) => selected.indexOf(v) > -1);

                    /**
                     * Nesse momento estou pegando os grupos que foram selecionados no cockpit e colocando dentro do array de filteredZoom para
                     * ser utilizaddo nas legendas.
                     *
                     * Exemplo -> O que veio do back: [ { grupo: 'SAFRA 01', AMENDOAS: 1 }, { grupo: 'SAFRA 02', AMENDOAS: 1, SOJA: 2 } ]
                     * No cockpit selecionamos apenas o grupo SAFRA 02, então no array de filteredZoom teremos ['SAFRA 02'] e no filtered ['SAFRA 01']
                     *
                     * Legenda:
                     * filtered -> dados que não foram selecionados no cockpit
                     * filteredZoom -> dados que foram selecioandos no cockpit com zoom
                     *
                     * Então sobreescrevo esses arrays mapeando os dados do back e identifico qual grupo está dentro do selecioando, assim
                     * pego as keys desse grupo. Então no primeiro caso irei adicionar dentro do filteredZoom AMENDOAS e SOJA e nisso removendo o primeiro item do array
                     * que teria no caso ['SAFRA 02'], então no final ele fica ['AMENDOAS', 'SOJA'].
                     *
                     * E no filtered terá apenas AMENDOAS, pois também removo o primeiro elemento que tinha ['SAFRA 01'], ficando apenas ['AMENDOAS'].
                     */
                    for (let i = 0; i < data.length; ++i) {
                        if (this.filteredZoom.includes(data[i].grupo)) {
                            Object.keys(data[i])
                                .slice(1)
                                .map((key) => this.filteredZoom.push(key));
                            this.filteredZoom.shift();
                        }

                        if (this.filtered.includes(data[i].grupo)) {
                            Object.keys(data[i])
                                .slice(1)
                                .map((key) => this.filtered.push(key));
                            this.filtered.shift();
                        }
                    }

                    // Aqui eu estou removendo os itens duplicados.
                    this.filtered = [...new Set(this.filtered)];
                    this.filteredZoom = [...new Set(this.filteredZoom)];

                    /**
                     * Nessa parte eu verifico se na seleção do zoom existe o item que pode conter no array dos itens que não foram selecionados.
                     * Lembrando que como ele é agrupado, em um grupo pode conter o mesmo item que outro grupo, porém se um grupo está exibindo significa que aquele item está sendo filtrado.
                     *
                     * Exemplo igual na parte de cima.
                     *
                     * No filtered ficou ['AMENDOAS']
                     * E no filteredZoom ficou ['AMENDOAS', 'SOJA']
                     *
                     * No caso o filtered está indicando que no grupo 1 SAFRA 01 não foi selecionado mas o AMENDOAS no grupo dois foi selecionado, então o memso é removido.
                     */
                    this.filtered = this.filtered.filter(
                        (elemento) => !this.filteredZoom.includes(elemento)
                    );

                    // Atualizar legenda
                    legends.style('opacity', (d) => {
                        if (this.filtered.length) {
                            if (this.filtered.indexOf(d) == -1 && this.filteredZoom == -1) {
                                return 1;
                            } else if (this.filteredZoom.indexOf(d) > -1) {
                                return 1;
                            } else {
                                return 0.4;
                            }
                        } else {
                            return 1;
                        }
                    });
                } else {
                    this.filtered = [];
                    legends.style('opacity', (d) => {
                        if (this.filtered.length) {
                            if (this.filtered.indexOf(d) == -1) {
                                return 1;
                            } else {
                                return 0.4;
                            }
                        } else {
                            return 1;
                        }
                    });
                }

                update(updatedData);
                exit();
                enter(updatedData);
                updateScale(updatedData);
            };

            // Seta o quadrado do zoom no gráfico inferior
            let updateScale = function (data) {
                let tickScale = d3
                    .scalePow()
                    .range([data.length / 10, 0])
                    .domain([data.length, 0])
                    .exponent(0.5);

                let brushValue = brush.extent()[1] - brush.extent()[0];
                if (brushValue === 0) {
                    brushValue = width;
                }

                let tickValueMultiplier = Math.ceil(Math.abs(tickScale(brushValue)));
                let filteredTickValues = data
                    .filter(function (d, i) {
                        return i % tickValueMultiplier === 0;
                    })
                    .map(function (d) {
                        return d.date;
                    });

                focus.select('.x.axis').call(xAxis.tickValues(filteredTickValues));
                focus.select('.y.axis').call(yAxis);
            };

            let update = (data) => {
                x.domain(
                    data.map(function (d) {
                        return d.grupo;
                    })
                );
                x4.domain(
                    data.map(function (d) {
                        return d.grupo;
                    })
                );
                x3.domain(keys).range([0, x4.bandwidth()]);
                y.domain([
                    0,
                    d3.max(data, function (d) {
                        return d3.max(Object.keys(d).slice(1), function (key) {
                            return d[key];
                        });
                    }),
                ]);

                // Criando os grupos das barras
                let bar = focus
                    .selectAll('.slice')
                    .data(data)
                    .enter()
                    .append('g')
                    .attr('class', 'g')
                    .attr('transform', function (d) {
                        return 'translate(' + x4(d.grupo) + ',0)';
                    });

                // Seta as barras dentro de cada grupo
                let bars = bar.selectAll('.bar').data(function (d) {
                    return Object.keys(d)
                        .slice(1)
                        .map(function (key) {
                            return { key: key, value: d[key] };
                        });
                });

                bars.attr('height', function (d) {
                    return height - y(d.value);
                })
                    .attr('width', function (d, i) {
                        return x3.bandwidth();
                    })
                    .attr('x', function (d) {
                        return x3(d.key);
                    })
                    .attr('y', function (d) {
                        return y(d.value);
                    })
                    .attr('fill', function (d) {
                        return color(d.key);
                    });
            };

            // Remove a sombra do gráfico
            let exit = function () {
                let bars = focus.selectAll('.g').data([]); // remove tudo
                bars.exit().remove();
            };

            // Criando o gráfico de cima
            let enter = (data) => {
                x.domain(
                    data.map(function (d) {
                        return d.grupo;
                    })
                );
                x4.domain(
                    data.map(function (d) {
                        return d.grupo;
                    })
                );
                let isSelected = selected && selected.length > 0;
                x3.domain(keys).range([0, isSelected ? x4.bandwidth() : x.bandwidth()]);
                y.domain([
                    0,
                    d3.max(data, function (d) {
                        return d3.max(Object.keys(d).slice(1), function (key) {
                            return d[key];
                        });
                    }),
                ]);

                // Configurações de cores das barras
                this.$d3
                    .selectAll('.selection')
                    .attr('height', '77px')
                    .attr('stroke', this.cores[0]);

                // Recriando os tooltips
                this.tooltipDiv.remove();

                this.tooltipDiv = this.$d3
                    .select('body')
                    .append('div')
                    .attr('class', 'chart-tooltip')
                    .style('opacity', 0);

                // Criando os grupos das barras
                let bar = focus
                    .selectAll('.slice')
                    .data(data)
                    .enter()
                    .append('g')
                    .attr('class', 'g')
                    .attr('transform', function (d) {
                        return 'translate(' + (isSelected ? x4(d.grupo) : x(d.grupo)) + ',0)';
                    });

                // Seta as barras dentro de cada grupo
                let bars = bar.selectAll('rect').data(function (d) {
                    return Object.keys(d)
                        .slice(1)
                        .map(function (key) {
                            return { key: key, value: d[key] };
                        });
                });

                // Definindo os tamanos das barras
                bars.enter()
                    .append('rect')
                    .attr('class', 'bars')
                    .attr('height', function (d) {
                        return height - y(d.value);
                    })
                    .attr('width', function (d) {
                        return x3.bandwidth();
                    })
                    .attr('x', function (d) {
                        return x3(d.key);
                    })
                    .attr('y', function (d) {
                        return y(d.value);
                    })
                    .attr('fill', (d) => color(d.key))
                    .on('mouseover', this.tooltipMouseoverEvt)
                    .on('mousemove', (d) => {
                        this.tooltipDiv
                            .style(
                                'left',
                                this.$d3.event.pageX - this.tooltipDiv.node().offsetWidth / 2 + 'px'
                            )
                            .style('top', this.$d3.event.pageY - 40 + 'px');
                    })
                    .on('mouseout', (d) => {
                        this.tooltipDiv.transition().duration(500).style('opacity', 0);
                    });
            };

            // Onde inicia a criação do gráfico.
            let margin = { top: 10, right: 10, bottom: 120, left: 40 },
                margin2 = {
                    top: this.$refs.chartContent.offsetHeight - 90,
                    right: 10,
                    bottom: 40,
                    left: 40,
                };
            let width = this.$refs.chartContent.offsetWidth - margin.left - margin.right;
            let cardWidth = this.$refs.chartContent.offsetWidth - margin.left - margin.right;
            let height = this.$refs.chartContent.offsetHeight - margin.top - margin.bottom;
            let height2 = this.$refs.chartContent.offsetHeight - margin2.top - margin2.bottom;

            // letiável indicando o tamanho do agrupamento quando o gráfico tiver muitos grupos
            let groupSize = 150;
            // altera width quando o gráfico tem muitos elementos, width = groupSize * this.dataset.length. Se o resultado
            // for menor que o this.$refs.chartContent.offsetWidth, mantém esse valor
            let calc = this.dataset.length * groupSize - margin.left - margin.right;
            width = width >= calc ? width : calc;

            let x = this.$d3.scaleBand().rangeRound([0, width]).paddingInner(0.1), // Dados do gráfico original
                x2 = this.$d3.scaleBand().rangeRound([0, width]).paddingInner(0.1), // Dados do gráfico zoom
                x3 = this.$d3.scaleBand().padding(0.05), // As colunas do gráfico agrupadas
                x4 = this.$d3.scaleBand().rangeRound([0, cardWidth]).paddingInner(0.1),
                y = this.$d3.scaleLinear().range([height, 0]), // Dados do gráfico original
                y2 = this.$d3.scaleLinear().range([height2, 0]); // Dados do gráfico zoom

            let color = this.$d3.scaleOrdinal(this.cores);

            let xAxis = this.$d3.axisBottom(x),
                xAxis2 = this.$d3.axisBottom(x),
                yAxis = this.$d3.axisLeft(y).tickFormat(this.customFormatter);

            this.tooltipDiv = this.$d3
                .select('body')
                .append('div')
                .attr('class', 'chart-tooltip')
                .style('opacity', 0);

            // Criação das colunas (aqui é exibido os grupos)
            let colNames = data.map(function (d) {
                return d.grupo;
            });

            // Para as legendas
            let keys = [];
            data.map((e) => {
                Object.keys(e)
                    .slice(1)
                    .map((item) => {
                        // se ainda não existe a cultura dentro das keys a mesma é adicionada
                        if (!keys.includes(item)) {
                            keys.push(item);
                        }
                    });
            });

            x.domain(colNames);
            x3.domain(keys).range([0, x.bandwidth()]);
            y.domain([
                0,
                this.$d3.max(data, (d) => {
                    return this.$d3.max(Object.keys(d).slice(1), function (key) {
                        return d[key];
                    });
                }),
            ]).nice();

            x2.domain(x.domain());
            y2.domain(y.domain());

            let brush = d3
                .brushX()
                .extent([
                    [0, 0],
                    [width, height],
                ])
                .on('brush', brushed)
                .on('start', () => {
                    this.$d3
                        .selectAll('.selection')
                        .attr('height', '77px')
                        .attr('stroke', this.cores[0]);
                    brushed();
                })
                .on('end', () => {
                    let extent = d3.event.selection;
                    if (!extent) {
                        this.closeZoom();
                    }
                });

            // Pegando o svg no template
            let svg = this.$d3.select(this.$refs.svgcontent);

            // Seta o tamanho do SVG para caso tenha muitos registros poder adicionar a barra de scroll no gráfico.
            svg.attr('width', width);

            // Criando o svg com o gráfico completo
            const chart = svg.append('g').attr('transform', 'translate(0,0)');

            /**
             * Criando o gráfico de cima
             * Encapsula os dados para forçar ele criar apenas um único focus e context
             *
             * Nesse caso o array por exemplo chegará assim [{}, {}].
             *
             * Então o array têm dois tamanhos, se passase diretamente esse array pro focus
             * ele iria criar dois focus no html, como queremos que crie apenas um então passamos
             * um array encapsulado [[{}, {}]], onde terá apenas uma posição e na mesma conterá
             * o array com objetos.
             */
            let dataEncapsulada = [data];

            let focus = chart
                .selectAll('focus-chart')
                .data(dataEncapsulada)
                .enter()
                .append('g')
                .attr('class', 'focus')
                .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

            focus
                .append('g')
                .attr('class', 'x axis')
                .attr('transform', 'translate(0,' + height + ')')
                .call(xAxis);

            focus.append('g').attr('class', 'y axis').call(yAxis);

            // Criando o gráfico de zoom
            let context = chart
                .selectAll('context-chart')
                .data(dataEncapsulada)
                .enter()
                .append('g')
                .attr('class', 'context')
                .attr('transform', function (d) {
                    return 'translate(' + margin2.left + ',' + margin2.top + ')';
                });

            enter(data);
            updateScale(data);

            let subBars = context
                .selectAll('.subBar')
                .data(this.preencheObjetosDadosFaltosos(data))
                .enter()
                .append('g')
                .attr('class', 'g')
                .attr('transform', function (d) {
                    return 'translate(' + x2(d.grupo) + ',0)';
                });

            let subBarsGroup = subBars.selectAll('.subBarGroup').data(function (d) {
                return Object.keys(d)
                    .slice(1)
                    .map(function (key) {
                        return { key: key, value: d[key] };
                    });
            });

            subBarsGroup
                .enter()
                .append('rect')
                .classed('subBar', true)
                .attr('height', function (d) {
                    return height2 - y2(d.value);
                })
                .attr('width', function (d, i) {
                    return x3.bandwidth();
                })
                .attr('x', function (d) {
                    return x3(d.key);
                })
                .attr('y', function (d) {
                    return y2(d.value);
                })
                .attr('fill', function (d) {
                    return '#c6c6c6';
                });

            context
                .append('g')
                .attr('class', 'x axis')
                .attr('transform', 'translate(0,' + height2 + ')')
                .call(xAxis2);

            context
                .append('g')
                .attr('class', 'x brush')
                .call(brush)
                .on('click', () => {
                    this.$d3
                        .selectAll('.selection')
                        .attr('height', '77px')
                        .attr('stroke', this.cores[0]);
                })
                .selectAll('rect')
                .attr('y', -6)
                .attr('height', height2 + 7);

            let legends = this.$d3
                .select(this.$refs.LGbox)
                .attr('font-family', 'sans-serif')
                .attr('font-size', 10)
                .attr('text-anchor', 'end')
                .selectAll('.legend')
                .data(color.domain())
                .enter()
                .append('div')
                .attr('class', 'legend-box')
                .on('click', (d) => {
                    // Atualize a matriz para filtrar o gráfico

                    // Adiciona a chave clicada se não estiver incluída
                    let filtered = [...this.filtered];
                    if (this.filtered.indexOf(d) == -1) {
                        this.filtered.push(d);
                        // se todas as barras estiverem desmarcadas, reinicia:
                        if (this.filtered.length == color.domain().length) {
                            if (!this.hasZoom) {
                                this.filtered = [];
                            } else {
                                this.filtered = filtered;
                            }
                        }
                    }
                    // Caso contrário, remova-o:
                    else {
                        this.filtered.splice(this.filtered.indexOf(d), 1);
                    }

                    // Atualize as escalas para os itens de cada grupo(/states):
                    let newKeys = [];
                    if (newKeys.length == 0) {
                        if (!this.hasZoom) {
                            color.domain().forEach((d1) => {
                                if (this.filtered.indexOf(d1) == -1 && d1) {
                                    newKeys.push(d1);
                                }
                            });
                        } else {
                            this.filteredZoom.forEach((d2) => {
                                if (this.filtered.indexOf(d2) == -1 && d2) {
                                    newKeys.push(d2);
                                }
                            });
                        }
                    }

                    x3.domain(newKeys).range([0, x.bandwidth()]);
                    y.domain([
                        0,
                        this.$d3.max(data, (d) => {
                            return this.$d3.max(newKeys, (key) => {
                                if (this.hasZoom) {
                                    if (this.filteredZoom.indexOf(key) > -1) return d[key];
                                } else {
                                    if (this.filtered.indexOf(key) == -1) return d[key];
                                }
                            });
                        }),
                    ]).nice();

                    // Atualiza o eixo y:
                    svg.select('.y').transition().call(yAxis).duration(500);

                    /**
                     * Filtra os dados que precisam ser ocultados
                     *
                     * Nessa parte precisamos fazer uma formatacao na forma como
                     * sera enviado os dados para as legendas ocultarem ou não as barras.
                     * Quando criamos o focus lá na parte de cima passamos um array encapsualado,
                     * no caso será um array de uma posição onde na primeira posição irá ter um outro
                     * array com vários objetos, nesse caso o array terá apenas 1 posição.
                     * Foi feito dessa forma para o cockpit criar apenas um
                     * focus (parte de cima) e o context (parte de baixo).
                     * Então o mesmo mapeia esse array de uma posição e adiciona todos os objetos dentro
                     * do dataFormatada, assim cada posição do array será um objeto com key e value.
                     */
                    let dataFormatada = [];
                    let bars = focus.selectAll('.bars').data(function (d) {
                        // verifico se existem grupos selecioandos, caso exista, mapeio os dados somente deste grupo e não de todos em si.
                        let dataTemp = [];
                        if (selected) {
                            dataTemp = d.filter((elemento) => {
                                return selected.includes(elemento.grupo);
                            });
                        } else {
                            dataTemp = d;
                        }
                        dataTemp.map((item) => {
                            Object.entries(item)
                                .slice(1)
                                .map((subItem) => {
                                    dataFormatada.push({
                                        key: subItem[0],
                                        value: subItem[1],
                                    });
                                });
                        });
                        return dataFormatada;
                    });

                    // Oculta as barras conforme a legenda selecionada:
                    bars.filter((d5) => {
                        return this.filtered.indexOf(d5.key) > -1;
                    })
                        .transition()
                        .attr('height', function (d5) {
                            return 0;
                        })
                        .attr('width', function (d5) {
                            return 0;
                        })
                        .attr('y', function (d5) {
                            return y(0);
                        })
                        .duration(500);

                    // Ajusta as barras restantes:
                    bars.filter((d6) => {
                        return this.filtered.indexOf(d6.key) == -1;
                    })
                        .transition()
                        .attr('x', function (d6) {
                            return x3(d6.key);
                        })
                        .attr('y', function (d6) {
                            return y(d6.value);
                        })
                        .attr('height', function (d6) {
                            return height - y(d6.value);
                        })
                        .attr('width', (d6) => {
                            return x3.bandwidth();
                        })
                        .attr('fill', function (d6) {
                            return color(d6.key);
                        })
                        .duration(500);

                    // Atualizar legenda:
                    legends.style('opacity', (d7) => {
                        if (!this.hasZoom) {
                            if (this.filtered.length) {
                                if (this.filtered.indexOf(d7) == -1) {
                                    return 1;
                                } else {
                                    return 0.4;
                                }
                            } else {
                                return 1;
                            }
                        } else {
                            if (this.filteredZoom.indexOf(d7) > -1) {
                                if (this.filtered.length) {
                                    if (this.filtered.indexOf(d7) == -1) {
                                        return 1;
                                    } else {
                                        return 0.4;
                                    }
                                } else {
                                    return 1;
                                }
                            } else {
                                return 0.4;
                            }
                        }
                    });
                });

            legends
                .append('div')
                .style('min-width', this.legendRectSize + 'px')
                .style('height', this.legendRectSize + 'px')
                .attr('class', 'legend-color-box')
                .style('background', color);

            legends
                .append('div')
                .style('text-transform', 'uppercase')
                .text(function (d) {
                    return d;
                });
        },
        svgChartNoZoom() {
            let width = this.$refs.chartContent.offsetWidth;
            let height = this.$refs.chartContent.offsetHeight;
            let margin = { top: 20, right: 20, bottom: 30, left: 40 };

            // letiável indicando o tamanho do agrupamento quando o gráfico tiver muitos grupos
            let groupSize = 150;
            // altera width quando o gráfico tem muitos elementos, width = groupSize * this.dataset.length. Se o resultado
            // for menor que o this.$refs.chartContent.offsetWidth, mantém esse valor
            let calc = this.dataset.length * groupSize;
            width = width >= calc ? width : calc;

            let w = width - margin.left - margin.right;
            let h = height - margin.top - margin.bottom;

            const svg = this.$d3.select(this.$refs.svgcontent);

            // Seta o tamanho do SVG para caso tenha muitos registros poder adicionar a barra de scroll no gráfico.
            svg.attr('width', width).attr('height', height);

            const chart = svg
                .append('g')
                .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

            let x0 = this.$d3.scaleBand().rangeRound([0, w]).paddingInner(0.1); // Eixo x para grupo de colunas

            let x1 = this.$d3.scaleBand().padding(0.05); // Tamanho de cada coluna do grupo

            let y = this.$d3.scaleLinear().rangeRound([h, 0]); // Altura da coluna

            let color = this.$d3.scaleOrdinal(this.cores); // Cores

            let xAxis = this.$d3.axisBottom(x0); // Começa no menor valor do eixo x0

            let yAxis = this.$d3.axisLeft(y).tickFormat(this.customFormatter); // Seta os valores do eixo y começando pelo menor valor em y

            this.tooltipDiv = this.$d3
                .select('body')
                .append('div')
                .attr('class', 'chart-tooltip')
                .style('opacity', 0);

            // Para construir o gráfico
            let data = this.dataset;

            // Para as legendas
            let keys = [];
            data.map((e) => {
                Object.keys(e)
                    .slice(1)
                    .map((item) => {
                        // se ainda não existe a cultura dentro das keys a mesma é adicionada
                        if (!keys.includes(item)) {
                            keys.push(item);
                        }
                    });
            });

            //Criação das colunas (aqui é exibido os grupos)
            let colNames = data.map(function (d) {
                return d.grupo;
            });

            x0.domain(colNames);
            x1.domain(keys).rangeRound([0, x0.bandwidth()]);
            y.domain([
                0,
                this.$d3.max(data, (d) => {
                    return this.$d3.max(Object.keys(d).slice(1), function (key) {
                        return d[key];
                    });
                }),
            ]).nice();

            chart
                .append('g')
                .attr('class', 'x axis')
                .attr('transform', 'translate(0,' + h + ')')
                .call(xAxis);

            chart.append('g').attr('class', 'y axis').style('opacity', '0').call(yAxis);

            chart.select('.y').transition().style('opacity', '1');

            let slice = chart
                .selectAll('.slice')
                .data(data)
                .enter()
                .append('g')
                .attr('class', 'g')
                .attr('transform', function (d) {
                    return 'translate(' + x0(d.grupo) + ',0)';
                });

            slice
                .selectAll('rect')
                .data(function (d) {
                    return Object.keys(d)
                        .slice(1)
                        .map(function (key) {
                            return { key: key, value: d[key] };
                        });
                })
                .enter()
                .append('rect')
                .attr('class', 'bars')
                .attr('width', x1.bandwidth())
                .attr('height', function (d) {
                    return h - y(d.value);
                })
                .attr('x', function (d) {
                    return x1(d.key);
                })
                .attr('y', function (d) {
                    return y(d.value);
                })
                .attr('fill', (d) => color(d.key))
                .on('mouseover', this.tooltipMouseoverEvt)
                .on('mousemove', (d) => {
                    this.tooltipDiv
                        .style(
                            'left',
                            this.$d3.event.pageX - this.tooltipDiv.node().offsetWidth / 2 + 'px'
                        )
                        .style('top', this.$d3.event.pageY - 40 + 'px');
                })
                .on('mouseout', (d) => {
                    this.tooltipDiv.transition().duration(500).style('opacity', 0);
                });

            let legends = this.$d3
                .select(this.$refs.LGbox)
                .attr('font-family', 'sans-serif')
                .attr('font-size', 10)
                .attr('text-anchor', 'end')
                .selectAll('.legend')
                .data(color.domain())
                .enter()
                .append('div')
                .attr('class', 'legend-box')
                .on('click', (d) => {
                    // Atualize a matriz para filtrar o gráfico por:

                    // adiciona a chave clicada se não estiver incluída:
                    if (this.filtered.indexOf(d) == -1) {
                        this.filtered.push(d);
                        // se todas as barras estiverem desmarcadas, reinicia:
                        if (this.filtered.length == color.domain().length) this.filtered = [];
                    }
                    // Caso contrário, remova-o:
                    else {
                        this.filtered.splice(this.filtered.indexOf(d), 1);
                    }

                    // Atualize as escalas para os itens de cada grupo(/states):
                    let newKeys = [];
                    color.domain().forEach((d20) => {
                        if (this.filtered.indexOf(d20) == -1 && d20) {
                            newKeys.push(d20);
                        }
                    });

                    x1.domain(newKeys).range([0, x0.bandwidth()]);
                    y.domain([
                        0,
                        this.$d3.max(data, (d) => {
                            return this.$d3.max(newKeys, (key) => {
                                if (this.filtered.indexOf(key) == -1) {
                                    return d[key];
                                }
                            });
                        }),
                    ]).nice();

                    // Atualiza o eixo y:
                    svg.select('.y').transition().call(yAxis).duration(500);

                    // Filtra os dados que precisam ser ocultados:
                    let bars = slice.selectAll('.bars').data(function (d22) {
                        return Object.entries(d22)
                            .slice(1)
                            .map((item) => ({
                                key: item[0],
                                value: item[1],
                            }));
                    });

                    // Oculta as barras conforme a legenda selecionada:
                    bars.filter((d23) => {
                        return this.filtered.indexOf(d23.key) > -1;
                    })
                        .transition()
                        .attr('height', function (d23) {
                            return 0;
                        })
                        .attr('width', function (d23) {
                            return 0;
                        })
                        .attr('y', function (d23) {
                            return y(0);
                        })
                        .duration(500);

                    // Ajusta as barras restantes:
                    bars.filter((d24) => {
                        return this.filtered.indexOf(d24.key) == -1;
                    })
                        .transition()
                        .attr('x', function (d24) {
                            return x1(d24.key);
                        })
                        .attr('y', function (d24) {
                            return y(d24.value);
                        })
                        .attr('height', function (d24) {
                            return h - y(d24.value);
                        })
                        .attr('width', (d24) => {
                            return x1.bandwidth();
                        })
                        .style('fill', function (d24) {
                            return color(d24.key);
                        })
                        .duration(500);

                    // Atualizar legenda:
                    legends.style('opacity', (d25) => {
                        if (this.filtered.length) {
                            if (this.filtered.indexOf(d25) == -1) {
                                return 1;
                            } else {
                                return 0.4;
                            }
                        } else {
                            return 1;
                        }
                    });
                });

            legends
                .append('div')
                .style('min-width', this.legendRectSize + 'px')
                .style('height', this.legendRectSize + 'px')
                .attr('class', 'legend-color-box')
                .style('background', color);

            legends
                .append('div')
                .style('text-transform', 'uppercase')
                .text(function (d) {
                    return d;
                });
        },
        hideData(d, i) {
            d.active = !d.active;
        },
        mountChart() {
            if (!this.noData) {
                setTimeout(() => {
                    if (this.zoomned) {
                        this.svgChart();
                    } else {
                        this.svgChartNoZoom();
                    }
                }, 10);
            }
        },
        redrawChart(clean = true) {
            if (clean) {
                this.cleanChart();
            }

            setTimeout(this.mountChart, 10);
        },
        cleanChart() {
            this.$d3.select(this.$refs.svgcontent).selectAll('g').remove();
            this.$d3.select(this.$refs.LGbox).selectAll('.legend-box').remove();

            if (this.tooltipDiv) {
                this.tooltipDiv.remove();
            }
        },
        /*  Este é o formatador que vai mostrar os números do eixo Y
        no gráfico. o "1,8k", "2,5M" e por aí vai. */
        customFormatter(number) {
            let p = this.formatter.formatToParts(number);

            let g = p.filter((e) => {
                return e.type == 'group';
            });

            if (g.length < 1) {
                return this.formatter.format(number);
            } else {
                let sufix = '';
                let value = '';

                if (p[0].value.length == 3) {
                    value = p[0].value;
                } else {
                    value = `${p[0].value}${
                        p[0].value.length < 2 ? this.$t('scale-separator') : ''
                    }${p[2].value.substring(0, 2 - p[0].value.length)}`;
                }

                switch (g.length) {
                    case 1:
                        sufix = 'k';
                        break;
                    case 2:
                        sufix = 'M';
                        break;
                    case 3:
                        sufix = 'B';
                        break;
                    case 4:
                        sufix = 'T';
                        break;
                }

                return `${value}${sufix}`;
            }
        },
        zoom() {
            this.zoomned = !this.zoomned;
            if (!this.zoomned) {
                this.hasZoom = false;
            }
            this.redrawChart();
        },
        closeZoom() {
            this.hasZoom = false;
            this.redrawChart();
        },
        /*  Handler de evento separado para o tooltip. Como ele é usado várias
        vezes durante o desenho do gráfico, foi colocado aqui para lidar uma vez só
        com o caso especial de mostrar a moeda no tooltip. */
        tooltipMouseoverEvt(d) {
            let temp = this.isCurrencyChart(this.datacontent.titulo)
                ? this.getDecimal(d.value, null, true)
                : this.getDecimal(d.value, 0, false);

            let msg = `<b>${d.key}:</b> ${temp}`;

            // .transition()
            this.tooltipDiv
                .html(msg)
                .transition()
                .duration(500)
                .style('opacity', this.legendOpacity)
                .style('color', '#FFF')
                .style('left', this.$d3.event.pageX - this.tooltipDiv.node().offsetWidth / 2 + 'px')
                .style('top', this.$d3.event.pageY - 40 + 'px');
        },
        preencheObjetosDadosFaltosos(lista) {
            let newList = JSON.parse(JSON.stringify(lista));
            // inicio da posição que irá ser começado para avaliação do preenchimento de dados.
            let inicio = 0;
            while (true) {
                let fim = newList.length - 1;
                for (let i = 0; i < fim; ++i) {
                    // caso o inicio não seja mais como 0 e seja diferente de i, no caso não atualizar o próprio objeto.
                    if (inicio != 0 && inicio != i) {
                        Object.keys(newList[i]).forEach((item) => {
                            if (!newList[inicio][item]) {
                                newList[inicio][item] = 0.1;
                            }
                        });
                    } else {
                        // caso seja 0 o inicio, sempre pegar as atualizações dos próximos objetos da newList.
                        Object.keys(newList[i + 1]).forEach((item) => {
                            if (!newList[inicio][item]) {
                                newList[inicio][item] = 0.1;
                            }
                        });
                    }
                }
                // valida se já encerrou os preenchimentos, se sim para o loop do while
                if (inicio < fim) {
                    inicio++;
                } else {
                    break;
                }
            }

            return newList;
        },
    },
};
</script>

<style lang="scss">
.axis {
    @include defaultFont();
    font-weight: 600;
    color: $darker-gray-color;
}

.legend-box > :not(.legend-color-box) {
    color: $darker-gray-color;
}

.cockpit-chart .chart-content svg {
    width: auto;
    height: auto;
}
</style>
